import { useState, useCallback } from 'react';

export const useAlerts = () => {
  const [alerts, setAlerts] = useState([]);

  const removeAlert = useCallback((id) => {
    setAlerts(prev => prev.filter(alert => alert.id !== id));
  }, []);

  const addAlert = useCallback((alert) => {
    const id = Date.now() + Math.random();
    const newAlert = {
      id,
      type: 'info',
      duration: 5000,
      dismissible: true,
      ...alert,
    };

    setAlerts(prev => [...prev, newAlert]);

    // Auto-dismiss se tiver duração definida
    if (newAlert.duration && newAlert.duration > 0) {
      setTimeout(() => {
        removeAlert(id);
      }, newAlert.duration);
    }

    return id;
  }, [removeAlert]);


  const clearAllAlerts = useCallback(() => {
    setAlerts([]);
  }, []);

  // Métodos de conveniência
  const showSuccess = useCallback((message, duration = 5000, options = {}) => {
    return addAlert({ type: 'success', message, duration, ...options });
  }, [addAlert]);

  const showError = useCallback((message, duration = 7000, options = {}) => {
    return addAlert({ type: 'danger', message, duration, ...options });
  }, [addAlert]);

  const showWarning = useCallback((message, duration = 6000, options = {}) => {
    return addAlert({ type: 'warning', message, duration, ...options });
  }, [addAlert]);

  const showInfo = useCallback((message, duration = 4000, options = {}) => {
    return addAlert({ type: 'info', message, duration, ...options });
  }, [addAlert]);

  return {
    alerts,
    addAlert,
    removeAlert,
    clearAllAlerts,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};